/**
 * Created by pajicv on 9/25/18.
 */

import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import AddIcon from '@material-ui/icons/Add';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  button: {
    top: 120,
    right: 150,
    position: 'fixed',
    width: 100,
    height: 100,
    transform: 'translate(-80%, -100)',
    zIndex: 1000
  },
  label: {
    top: 240,
    right: 150,
    position: 'fixed',
    transform: 'translate(-80%, -100)',
    zIndex: 1000,
    fontSize: 18,
    fontWeight: 'bold'
  }
});

const CreateProjectButton = ({ classes, onClick, title, disabled }) => (
  <React.Fragment>
    <Button
      variant="fab"
      color="primary"
      aria-label="Add"
      className={classes.button}
      onClick={onClick}
      disabled={disabled}
    >
      <AddIcon />
    </Button>
      <Typography style={{ opacity: disabled ? 0.3 : 1 }} className={classes.label}>{title}</Typography>
  </React.Fragment>
);

CreateProjectButton.propTypes = {
  classes: PropTypes.object.isRequired,
    onClick: PropTypes.func.isRequired
};

export default withStyles(styles)(CreateProjectButton);



// WEBPACK FOOTER //
// ./src/components/Cycles/AddCycleButton.js